import { addElement, addText, empty, getNewId, setStyles } from 'sesajs-dom'
import { niveaux } from 'sesatheque-client/src/config'

import imgClose from './assets/close.png'

// on gère qq overrides d'après l'url

const isDev = /^(localhost|.+\.local|.+\.dev)$/.test(location.hostname) && !/env=prod/.test(location.search)
const hasLevelPrinted = /niveaux=1/.test(location.search)

const baseId = isDev ? 'sesabidev' : 'sesabibli'
const baseUrl = `https://bibliotheque.sesamath.${isDev ? 'dev' : 'net'}/`
const masterId = '5bcc89dc129e5b1076e56616'

const splitRe = new RegExp(`^(?:${baseId}/)?([a-z0-9]+)$`)

const elts = {
  /** @type {HTMLElement} */
  arbre: null,
  /** @type {HTMLElement} */
  display: null,
  /** @type {HTMLElement} */
  divIep: null,
  /** @type {HTMLElement} */
  errors: null,
  /** @type {HTMLElement} */
  menu: null,
  /** @type {HTMLElement} */
  titre: null
}

// Le rid de l'animation chargée (pour éviter de tout recharger si on ferme l'animation et rouvre la même)
let currentRid

const getUrl = (id) => `${baseUrl}api/public/${id}`

function showError (error) {
  console.error(error)
  empty(elts.errors)
  addText(elts.errors, error.message || error)
}

/**
 * Retourne la ressource rid chargée sur sa Sésathèque
 * @param rid
 * @return {Promise<Ressource>}
 */
async function load (rid) {
  const chunks = splitRe.exec(rid)
  if (!chunks || !chunks[1]) throw Error(`id|rid invalide : ${rid}`)
  const response = await fetch(getUrl(chunks[1]))
  const json = await response.json()
  if (json.message === 'OK' && json.data) return json.data
  throw Error(json.message || `Problème de chargement pour ${rid}`)
}

function hideIep () {
  elts.menu.style.display = 'block'
  elts.display.style.display = 'none'
  elts.titre.style.display = 'none'
  location.hash = ''
}
function showIep () {
  elts.menu.style.display = 'none'
  elts.display.style.display = 'block'
  elts.titre.style.display = 'inline'
  if (currentRid) {
    location.hash = `#${currentRid}`
    // si y'a déjà une animation on la relance
    const svg = elts.divIep.querySelector('svg')
    if (svg && svg.iepDoc) {
      svg.iepDoc.restart()
    }
  }
}

async function display (rid) {
  empty(elts.errors)
  showIep()
  if (currentRid === rid) return
  try {
    empty(elts.divIep)
    empty(elts.titre)
    addText(elts.divIep, 'Chargement en cours…')
    const ress = await load(rid)
    if (ress.type !== 'iep') throw Error(`La ressource ${rid} n’était pas une animation instrumenpoche`)
    const xml = ress.parametres && (ress.parametres.xml || ress.parametres.url)
    if (!xml) throw Error(`La ressource ${rid} n’était pas une animation instrumenpoche (pas trouvé le script de l’animation)`)
    const { default: iepLoadPromise } = await import('instrumenpoche')
    await iepLoadPromise(elts.divIep, xml)
    currentRid = rid
    addText(elts.titre, ress.titre)
    // on ajoute les niveaux si on le réclame
    if (hasLevelPrinted) {
      addElement(elts.titre, 'span', { style: { fontSize: '0.8em' } }, `(${ress.niveaux.map(n => niveaux[n]).join(', ')})`)
    }
  } catch (error) {
    showError(error)
    hideIep()
  }
}

function addEnfants (arbre, enfants) {
  if (!Array.isArray(enfants) || !enfants.length) return
  enfants.forEach(({ aliasOf, enfants, titre, type }) => {
    if (type === 'arbre') {
      const li = addElement(arbre, 'li', { className: 'folder' })
      // on ajoute un checkbox (pour gérer l'état on/off) suivi d'un label
      // label doit être après l'input pour que le sélecteur css (input ~_label) fonctionne
      const id = getNewId()
      addElement(li, 'input', { id, type: 'checkbox', checked: true })
      addElement(li, 'label', { for: id }, titre)
      const ul = addElement(li, 'ul', {})
      if (enfants && enfants.length) {
        addEnfants(ul, enfants)
      } else if (aliasOf) {
        load(aliasOf).then(({ enfants }) => addEnfants(ul, enfants))
      } else {
        addElement(ul, 'li', 'Dossier vide') // pour signifier que ce n'est pas un bug
      }
    } else if (type === 'iep') {
      const li = addElement(arbre, 'li')
      addElement(li, 'a', { href: `#${aliasOf}` }, titre)
    } else {
      console.error(Error(`enfant de type ${type} dans l’arbre iep`), { titre, aliasOf })
    }
  })
}

function initDom () {
  Object.keys(elts).forEach(name => {
    if (name === 'divIep') return // lui on s'en occupe juste après
    elts[name] = document.getElementById(name)
    if (!elts[name]) throw Error(`Il manque #${name} dans le html`)
  })
  // ajout de l'image pour fermer l'animation
  setStyles(elts.display, { position: 'relative', zIndex: 5 })
  const img = addElement(elts.display, 'img', { src: imgClose, alt: 'fermer', style: { position: 'absolute', top: 0, right: 0, zIndex: 10 } })
  img.addEventListener('click', hideIep)
  elts.divIep = addElement(elts.display, 'div')
}

function refresh () {
  const hash = location.hash.substr(1)
  if (!hash) return hideIep()
  if (currentRid && (hash === currentRid || hash === currentRid.split('/').pop())) return showIep()
  // on veut choper une erreur ici pour ne pas la faire suivre à bugsnag
  try {
    display(hash)
  } catch (error) {
    showError(error)
  }
}
function collapseAll () {
  elts.arbre.querySelectorAll('li.folder > input').forEach(input => {
    input.checked = false
  })
}
function expandAll () {
  elts.arbre.querySelectorAll('li.folder > input').forEach(input => {
    input.checked = true
  })
}

async function iepBibliLoad (containers) {
  let ress
  try {
    initDom(containers)
    ress = await load(masterId)
    if (!ress || ress.type !== 'arbre' || !Array.isArray(ress.enfants) || !ress.enfants.length) {
      throw Error(`Arbre invalide récupéré sur ${getUrl(masterId)}`)
    }
  } catch (error) {
    console.error(error)
    return showError('Impossible de charger la liste des ressources de la bibliothèque Instrumenpoche')
  }
  try {
    empty(elts.arbre)
    const p = addElement(elts.arbre, 'p')
    let elt = addElement(p, 'a', { href: '#', style: { margin: '0.2em' } }, 'tout replier')
    elt.addEventListener('click', collapseAll)
    addText(p, ' · ')
    elt = addElement(p, 'a', { href: '#', style: { margin: '0.2em' } }, 'tout déplier')
    elt.addEventListener('click', expandAll)
    const ul = addElement(elts.arbre, 'ul')
    addEnfants(ul, ress.enfants)
    window.addEventListener('hashchange', refresh)
    refresh()
  } catch (error) {
    console.error(error)
    return showError('Un problème est survenu lors de l’affichage de l’arbre des ressources instrumenpoche')
  }
  try {
    // l'affichage du menu est terminé, on lance le chargement du player dès maintenant, pour limiter le lag au premier clic
    // (il est installé via une dépendance déclarée dans le package.json)
    await import('instrumenpoche')
  } catch (error) {
    console.error(error)
    showError('Le chargement du lecteur instrumenpoche a échoué, les animations ne vont probablement pas s’afficher')
  }
}

iepBibliLoad({ arbre: 'arbre', display: 'display', errors: 'errors' })
